import React, { useEffect, useState } from "react";
import {
  addPersonnelDoc,
  deletePersonnelDocById,
  getPersonnelDocByUserId,
} from "../../Services/Pointeuse/PersonnelDocApi";
import * as FileSaver from "file-saver";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { t } from "i18next";
import { toast } from "react-toastify";
import { IoRefresh } from "react-icons/io5";
import { Spinner } from "react-bootstrap";
function CardDocument({ idUser }) {
  const [documents, setdocuments] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [imageName, setimageName] = useState("Choisir un document ...");
  const [type, settype] = useState("identite");
  const api_url = process.env.REACT_APP_API_URL;
  const [reload,setreload]=useState(false)

  const handleUploadFiles = (event) => {
    setFilesToUpload(URL.createObjectURL(event.target.files[0]));
    setImageUrl(event.target.files[0]);
    setimageName(event.target.files[0].name);
  };

  /**
   * * Add a new document to the database
   */
  const submitFiles = () => {
    addPersonnelDoc(idUser, imageUrl, type).then(() => {
      getAllDocuments();
    });
  };


  useEffect(()=>{
      setreload(false)
  },[documents])
  /**
   * It deletes a document from the database.
   * @param id - The id of the document to delete.
   */
  const handleDeleteFile = (id) => {
    swal({
      title: t("Ëtes-vous sûr ?"),
      text: t("Une fois supprimé, vous ne pourrez pas récupérer cet enregistrement!"),
      icon: "warning",
      // buttons: true,
      buttons: {
        cancel: t("Cancel"), // Traduisez le bouton "Cancel"
        confirm: {
          text: t("OK"), // Traduisez le bouton "OK"
          value: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deletePersonnelDocById(id).then(() => {
          swal(t("Opération effectuée avec succès!"), {
            icon: "success",
          });
          getAllDocuments();
        });
      }
    });
  };

  useEffect(() => {
    
    getAllDocuments();
  
  }, [idUser]);
  

  /**
   * Get all documents for a user
   */
  const getAllDocuments = () => {
    setreload(true)
    getPersonnelDocByUserId(idUser).then((resDocument) => {
      setdocuments(resDocument.data);
    });
  };

  /**
   * It saves the file to the local machine.
   * @param file - The file to download.
   */
  const saveFile = (Nomfile) => {
    const newTab = window.open(`${api_url}${Nomfile}`, '_blank');
    if (newTab) {
      // If the new tab was successfully opened, you can focus on it (optional)
      newTab.focus();
    } else {
      toast.error('Popup blocker prevented opening a new tab.');
    }
  };

  return (
    <div className="card-body">
      {reload ? (
        <div>
        <Spinner/>
        </div>):
        <div className="btn btn-primary float-md-right"  onClick={getAllDocuments}><IoRefresh /></div>}

      <div className="row">
        {documents.map((el) => (
          <div key={el.id} className="col-xl-3 col-md-4 col-sm-6">
            <div className="card border p-0 shadow-none">
              <div className="d-flex align-items-center px-4 pt-4">
                {/* <label className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="example-checkbox2"
                    defaultValue="option2"
                  />
                  <span className="custom-control-label" />
                </label> */}
                <div className="float-right ml-auto">
                  <div className="btn-group ml-3 mb-0">
                    <Link
                      to="#"
                      className="option-dots"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="fa fa-ellipsis-v" />
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                      {/* <a className="dropdown-item" href="#">
                        <i className="fe fe-edit mr-2" /> Edit
                      </a> */}
                      {/* <Link to="#" className="dropdown-item">
                        <i className="fe fe-share mr-2" /> Partager
                      </Link> */}
                      <Link to="#" className="dropdown-item" onClick={() => saveFile(el.image)}>
                        <i className="fe fe-download mr-2" /> {t("Télécharger")}
                      </Link>
                      <Link to="#" className="dropdown-item" onClick={() => handleDeleteFile(el.id)}>
                        <i className="fe fe-trash mr-2" /> {t("Supprimer")}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0 text-center">
                <div className="file-manger-icon">
                  {/* <img src="assets/images/files/file.png" alt="img" className="br-7" /> */}
                  {["png", "jpg", "jpeg", "PNG"].some((element) => el.image.split(".").pop().includes(element)) && (
                    <img src="https://coderthemes.com/highdmin/layouts/assets/images/file_icons/jpg.svg" alt="icon" />
                  )}
                  {el.image.split(".").pop() === "pdf" && (
                    <img src="https://coderthemes.com/highdmin/layouts/assets/images/file_icons/pdf.svg" alt="icon" />
                  )}
                  {el.image.split(".").pop() === "docx" && (
                    <img src="https://coderthemes.com/highdmin/layouts/assets/images/file_icons/doc.svg" alt="icon" />
                  )}
                </div>
                <h6 className="mb-1 font-weight-semibold mt-4">{el.image.split("Z")[1]}</h6>

                {el.type == "contrat" && <span className="text-muted">{t("Contrat")}</span>}
                {el.type == "identite" && <span className="text-muted">{t("Identité")}</span>}
                {el.type == "permis" && <span className="text-muted">{t("Permis")}</span>}
                {el.type == "rib" && <span className="text-muted">{t("RIB")}</span>}
                {el.type == "certificat de salaire" && <span className="text-muted">{t("certificat de salaire")}</span>}
                {el.type == "Attestation de travail" && <span className="text-muted">{t("Attestation de travail")}</span>}

                {el.type == "autre" && <span className="text-muted">{t("Autre")}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="form-group">
        <div className="row">
          {/* <div className="col-md-3">
            <div className="form-label mb-0 mt-2">Ajouter documents</div>
          </div> */}
          <div className="col-md-12">
            {/* <div className="form-group">
              <div className="custom-file">
                <input
                  className="custom-file-input"
                  accept="image/*"
                  type="file"
                  id="exampleInputFile"
                  onChange={handleUploadFiles}
                />
                <label className="custom-file-label" htmlFor="exampleInputFile">
                  {imageName}
                </label>

                <small className="form-text text-muted">
                  Documents autorisés: jpg, jpeg, png, pdf, docx. Maximum 1 fichier.
                </small>
              </div>
            </div> */}

            <div className="input-group file-browser">
              <input
                type="text"
                className="form-control browse-file"
                placeholder={imageName || "choisir un fichier ..."}
              />
              <label className="input-group-append">
                <span className="btn btn-primary">
                  {t("choisir fichier")} <input type="file" style={{ display: "none" }} onChange={handleUploadFiles} />
                </span>
              </label>
            </div>
            <small className="form-text text-muted  mb-5">
              {t("Documents autorisés")}: jpg, jpeg, png, pdf. {t("Maximum 1 fichier")}.
            </small>

            <div>
              <div className="form-group">
                <label htmlFor="exampleFormControlSelect1">{t("Type document")}</label>
                <select
                  value={type}
                  className="form-control"
                  id="exampleFormControlSelect1"
                  onChange={(e) => settype(e.target.value)}
                >
                  <option value="identite">{t("Identité")}</option>
                  <option value="contrat">{t("Contrat")}</option>
                  <option value="permis">{t("Permis")}</option>
                  <option value="rib">{t("RIB")}</option>
                  <option value="autre">{t("Autre")}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-right">
        <Link to="#" className="btn btn-primary mr-2" onClick={submitFiles}>
          {t("Enregistrer")}
        </Link>
        {/* <a href="#" className="btn btn-danger">
                          Cancle
                        </a> */}
      </div>
    </div>
  );
}

export default CardDocument;
